export default __webpack_public_path__ + "static/media/loader.a5899053.gif";